module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Bold.08109438.ttf";